import api from "./axios";
import GetZendeskSsoUrlResponse from "../responses/GetZendeskSsoUrlResponse";
import { Environment } from "../utils/environment";
import { useTenantConfig } from "../composables/useTenantConfig";

class ZendeskService {
  async getZendeskSSOUrl() {
    try {
      const response = await api.get("/zendesk/sso");
      return response.data as GetZendeskSsoUrlResponse;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(
          "There was an error getting Zendesk SSO URL: " + error.message
        );
      }
      throw new Error(
        "An unknown error occurred while getting Zendesk SSO URL"
      );
    }
  }

  async getZendeskNavigationUrl(pageType: "missingPoints" | "contactUs" | "faq" | "memberServices" | "manageAccount", isAuthenticated: boolean) {
    //const isProd = Environment.isProduction; // Temporarily disabled till Sandbox is ready
    const isProd = true; // Remove this line when Sandbox is ready
    const isStaging = Environment.isStaging;
    const { urls } = useTenantConfig();  

    const urlKeys = {
      missingPoints:
        isProd || isStaging
          ? urls.value.zendesk.missingPointsUrl_live
          : urls.value.zendesk.missingPointsUrl_test,
      contactUs:
        isProd || isStaging
          ? urls.value.zendesk.contactUsUrl_live
          : urls.value.zendesk.contactUsUrl_test,
      faq:
        isProd || isStaging
          ? urls.value.zendesk.faqUrl_live
          : urls.value.zendesk.faqUrl_test,
      memberServices:
        isProd || isStaging
          ? urls.value.zendesk.memberServicesUrl_live
          : urls.value.zendesk.memberServicesUrl_test,
      manageAccount:
        isProd || isStaging
          ? urls.value.zendesk.manageAccountUrl_live
          : urls.value.zendesk.manageAccountUrl_test,
    };

    let targetUrl = urlKeys[pageType];
    if (isAuthenticated) {
      const ssoResponse = await this.getZendeskSSOUrl();

      if (ssoResponse?.isSuccess && ssoResponse.url) {
        targetUrl = ssoResponse.url + targetUrl;
      }
    }

    return targetUrl;
  }
}

export default new ZendeskService();
